export const Team = (props) => {
  return (
    <div id='team' className='text-center'>
      <div className='container'>
        <div className='col-md-8 col-md-offset-2 section-title'>
          <h2>Meet the Team</h2>
          <p>
            Please check out our main website to check the all members and our services. <br />
            <a href="https://kruschecompany.com/web-and-cloud-technologies-it-outsourcing/">Go for discussion</a>
          </p>
        </div>
        <div id='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-3 col-sm-6 team'>
                  <div className='thumbnail'>
                    {' '}
                    {/* <img src={d.img} alt='...' className='team-img' /> */}
                    <img src="https://shorelineventures.com/wp-content/uploads/2016/07/team-member-icon.png" alt='...' className='team-img' />
                    
                    <div className='caption'>
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
